import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function NotesPanel({ callId, contactId }) {
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [noteType, setNoteType] = useState('general');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (callId) {
      fetchNotes();
    }
  }, [callId]);

  const fetchNotes = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/calls/${callId}/notes`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotes(response.data || []);
    } catch (error) {
      console.error('Error fetching notes:', error);
    }
  };

  const handleAddNote = async (e) => {
    e.preventDefault();
    if (!newNote.trim()) return;

    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(
        `${API_BASE}/dialer/calls/${callId}/notes`,
        {
          note: newNote,
          note_type: noteType
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotes([response.data, ...notes]);
      setNewNote('');
    } catch (error) {
      console.error('Error adding note:', error);
      alert('Failed to add note');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h3 className="text-lg font-semibold mb-4">Notes</h3>

      <form onSubmit={handleAddNote} className="mb-4">
        <textarea
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          placeholder="Add a note..."
          className="w-full border rounded p-2 mb-2"
          rows="3"
        />
        <div className="flex items-center gap-2">
          <select
            value={noteType}
            onChange={(e) => setNoteType(e.target.value)}
            className="border rounded px-2 py-1 text-sm"
          >
            <option value="general">General</option>
            <option value="follow_up">Follow Up</option>
            <option value="objection">Objection</option>
            <option value="sale">Sale</option>
            <option value="callback">Callback</option>
          </select>
          <button
            type="submit"
            disabled={loading || !newNote.trim()}
            className="bg-blue-600 text-white px-4 py-1 rounded text-sm hover:bg-blue-700 disabled:bg-gray-400"
          >
            Add Note
          </button>
        </div>
      </form>

      <div className="space-y-2 max-h-64 overflow-y-auto">
        {notes.length === 0 ? (
          <div className="text-center py-4 text-gray-500">No notes yet</div>
        ) : (
          notes.map((note) => (
            <div key={note.id} className="border rounded p-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-gray-500">{note.note_type}</span>
                <span className="text-xs text-gray-500">
                  {new Date(note.created_at).toLocaleString()}
                </span>
              </div>
              <div className="text-sm">{note.note}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}


